<template>
  <span>{{ props.text }} <i class="pi pi-copy" /></span>
</template>

<script setup lang="ts">
import { useToasterStore } from "@/stores/toaster";

const props = defineProps<{ text: string }>();
const toaster = useToasterStore();

function handleClick() {
  navigator.clipboard.writeText(props.text);
  toaster.add({ summary: "Copied to clipboard" });
}
</script>

<style scoped></style>
